import axios from "axios";
import {
  EstrategiaIdAgendamento,
  validarEstrategiaIdAgendamento,
} from "../helpers/estrategiaIdAgendamento";

type RespostaEstrategiaIdAgendamento = {
  success: boolean;
  estrategiaIdAgendamento: unknown;
};

class EstrategiaIdAgendamentoService {
  private api = axios.create({
    baseURL: `${process.env.REACT_APP_AXYMA_MICROSSERVICES_APIS_URL}/empresa/public`,
  });

  obter = async (empresaId: string): Promise<EstrategiaIdAgendamento> => {
    const { data } = await this.api.get<RespostaEstrategiaIdAgendamento>(
      `/fluxo-config/${encodeURIComponent(empresaId)}`,
    );
    if (!data.success) {
      throw new Error("Não foi possível carregar a estratégia de identificação.");
    }
    return validarEstrategiaIdAgendamento(data.estrategiaIdAgendamento);
  };
}

export default EstrategiaIdAgendamentoService;
